<div class="mat-slider-wrapper" #sliderWrapper>
  <div class="mat-slider-track-wrapper">
    <div class="mat-slider-track-fill" [ngStyle]="_getTrackFillStyles()"></div>
  </div>
  <div class="mat-slider-thumb-container" [ngStyle]="_thumbContainerStyles">
    <div class="mat-slider-thumb"></div>
  </div>
</div>
